import React, { useState } from 'react';
import { styled } from '../../../libs/styled.es.js';
import { useRouter } from 'next/router';
import { SvgIcon } from '../../atoms/SvgIcon/SvgIcon.es.js';

const ScrollToTopBtn = styled.div((props) => `
  border-radius: 50%;
  background-color: ${props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
`);
const ScrollToTopWrapper = styled.div(({ showScroll, position }) => `
  display: ${showScroll ? 'block' : 'none'};
  z-index: 1030;
  position: fixed;
  ${position.bottom ? `bottom: ${position.bottom}rem;` : ''}
  ${position.top ? `top: ${position.top}rem;` : ''}
  ${position.left ? `left: ${position.left}rem;` : ''}
  ${position.right ? `right: ${position.right}rem;` : ''}
  cursor: pointer;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.5;
    }
  }
`);
const ScrollTopArrow = ({ className, color = '#ffffff', backgroundColor = ' #333333', position = { bottom: 10, right: 3 }, scrollTopRouters, }) => {
    const router = useRouter();
    const [showScroll, setShowScroll] = useState(false);
    const scrollTopTop = () => {
        if (typeof window !== 'undefined')
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    };
    const checkScrollTop = () => {
        if (typeof window !== 'undefined') {
            if (!showScroll && window.pageYOffset > 700) {
                setShowScroll(true);
            }
            else if (showScroll && window.pageYOffset <= 700) {
                setShowScroll(false);
            }
        }
    };
    if (typeof window !== 'undefined')
        window.addEventListener('scroll', checkScrollTop);
    let hasRouter = false;
    (scrollTopRouters === null || scrollTopRouters === void 0 ? void 0 : scrollTopRouters.length) > 0 &&
        scrollTopRouters.forEach((route) => {
            if (router.pathname.startsWith(route)) {
                hasRouter = true;
                return;
            }
        });
    if ((scrollTopRouters === null || scrollTopRouters === void 0 ? void 0 : scrollTopRouters.length) > 0 && !hasRouter)
        return null;
    return (React.createElement(ScrollToTopWrapper, { showScroll: showScroll, "data-track-content": true, "data-content-region-name": "btnScrollTop", "data-content-name": "btnScrollTop", position: position },
        React.createElement(ScrollToTopBtn, { className: className, onClick: () => scrollTopTop(), backgroundColor: backgroundColor },
            React.createElement(SvgIcon, { name: "up", size: 24, color: color }))));
};

export { ScrollTopArrow };
